'use client';

import React from 'react';
import { css, cx } from 'styled-system/css';

import { Checkbox } from '@shaojiang/components/ui/checkbox';
import { useTodoStore } from '@shaojiang/store/todo';

const doneStyle = css({ textDecoration: 'line-through', opacity: 0.5 });

export default function Tasks() {
  const tasks = useTodoStore((state) => state.tasks);
  const toggleTaskDone = useTodoStore((state) => state.toggleTaskDone);

  return (
    <ul className={css({ my: '2' })}>
      {tasks.map((task) => (
        <li key={task.key}>
          <Checkbox
            fullWidth={false}
            w='full'
            checked={task.done}
            onCheckedChange={() => toggleTaskDone(task.key)}
            labelProps={{
              className: cx(
                css({ transition: 'all 0.2s', fontWeight: 'normal' }),
                task.done && doneStyle,
              ),
            }}
          >
            {task.content}
          </Checkbox>
        </li>
      ))}
    </ul>
  );
}
